module.exports = __webpack_public_path__ + "img/facebook.de7bb03c.svg";